module.exports = __webpack_public_path__ + "img/img (31).7552dc6a.png";